import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

export const ContentLoading = () => {
  const theme = useTheme()

  return (
    <ContentLoader
      speed={2}
      width={100}
      height={20}
      viewBox="0 0 100 20"
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
    >
      <rect x="0" y="0" rx="4" ry="4" width="100" height="20" />
    </ContentLoader>
  )
}
